import axios from 'axios'
import qs from 'qs'
import {
	// MessageBox,
	Message
} from 'element-ui'
import store from '@/store'
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
	timeout: 60000, // request timeout
	paramsSerializer: params => {
		return qs.stringify(params, {
			indices: false
		})
	}
})
// request interceptor
service.interceptors.request.use(
	config => {
		if (config.method == 'get') {
			const reqData = {
				...config.data
			}
			config.params = reqData
		}
		//发起请求时保存页面所有请求
		config.cancelToken = new axios.CancelToken(cancel => {
			store.dispatch('app/pushPromise', {
				cancel
			})
		});
		return config
	},
	error => {
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	response => {
		const res = response.data
		if (res.code !== 200) {

			if (res.code == 10017) {
				Message({
					message: res.data+'，请重新登录',
					type: 'error',
					duration: 2 * 1000
				})
				store.dispatch('user/resetToken')
				store.commit('user/SET_NAME', null)
				store.commit('user/SET_INFOSTATUS', false)
			}
			return Promise.reject(new Error(res.message || 'Error'))
		} else {
			return res
		}
	},
	error => {
		if (axios.isCancel(error)) {
			// 为了终结promise链 (实际请求不会走到.catch(rej=>{}),这样就不会触发错误提示之类的)
			return new Promise(() => {});
		} else {
			console.error('err' + error) // for debug
			if (error.response) {
				switch (error.response.status) {
					case 401:
						// 返回 401
						Message({
							message: '无权限访问,请联系商务',
							type: 'error',
							duration: 2 * 1000
						})
				}
			}
			return Promise.reject(error)
		}


	}
)

export default service
